import axios from '@/libs/api.request'
import url from '@/config/url'
const app_type = 3
const errorMsg = [
    {errCode:-1,errMsg:"手机号码不能为空"},
    {errCode:-2,errMsg:"验证码不能为空"},
    {errCode:-3,errMsg:"验证码错误"},
    {errCode:-4,errMsg:"手机号码不正确"},
]
class Db  {
    install(Vue){
        let db = this
        Vue.mixin({
            created: function () {
                this.$db = db
            }
        })
        this.config = url
    }
    constructor() {
        this.page = 1
        this.pageSize = 10
        this.search = []
        this.orderBy = ''
        this.order = ''
        this.params = []
    }
    /**
     * 请求地址
     * @param {[type]} url [description]
     */
    setUrl(url){
        this.url = url
    }
    /**
     * url 带过来的参数
     */
    setParams(params){
        this.params = params 
    }
    /**
     * 搜索条件
     * @param {[type]} search [description]
     */
    setSearch(search){
        this.search = search
    }
    /**
     * 跳转页码
     * @param {[type]} page [description]
     */
    setPage(page){

        //setLocalStorage('accessToken',"")
        //storeData.state.accessToken = page
        this.page = page
    }
    /**
     * 设置每页显示条数
     * @param {[type]} pageSize [description]
     */
    setPageSize(pageSize){
        this.pageSize = pageSize
    }
    /**
     * 设置排序key
     * @param {[type]} orderBy [description]
     */
    setOrderBy(orderBy){
        this.orderBy = orderBy
    }
    /**
     * 设置正序或倒序
     * @param {[type]} order [description]
     */
    setOrder(order){
        this.order = order
    }

    /**
     * 数据列表查询
     * @param {*} url 
     */
    list(url,isPage=true) {
        let data = {
            page:this.page,
            page_size:isPage?this.pageSize:0,
            order_by:this.orderBy,
            order:this.order
        }
        Object.assign(data, this.search)
        return axios.request({
            url:url,
            data,
            method:'post'
        })
        //return this.before(url,data)
    }

    /**
     * 所有获取单个信息的方法
     * @param {} url 
     */
    get(url){
        let data = {
            
        }
        return axios.request({
            url:url,
            data,
            method:'get'
        })
    }

    /**
     * 所有编辑用put方法
     */
    put(url,params){
        let data = {
            
        }
        Object.assign(data, params);
        return axios.request({
            url:url,
            data,
            method:'put'
        })
    }

    /**
     * 所有删除用delete方法
     */
    delete(url){
        let data = {
            
        }
        return axios.request({
            url:url,
            data,
            method:'delete'
        })
    }

    /**
     * 所有新增操作用post方法
     */
    post(url,params){
        let data = {
            
        }
        Object.assign(data, params);
        return axios.request({
            url:url,
            data,
            method:'post'
        })
    }


    before(url,data){
        let accessToken = getLocalStorage('access-token')
        if(accessToken){
            data['access-token'] = accessToken
            return axios.request({
                url:url,
                data,
                method:'post'
            })
        }else{
            return this.getAccessToken().then(resp=>{
                accessToken = resp.data['access-token']
                setLocalStorage('access-token',accessToken)
                return accessToken
            }).then(resp=>{
                data['access-token'] = resp
                return axios.request({
                    url:url,
                    data,
                    method:'post'
                })
            })
        }
    }
    getAccessToken(){
        let data = {
            app_type:app_type,
        }
        return axios.request({
            url:this.config.public.token,
            data,
            method:'post'
        })
    }

    /**
     * 获取验证码
     * @param {*} param0 
     */
    getSmsCode({mobile,token,success,error}){
        if(!mobile){error && error(errorMsg[0]);return false}
        if(mobile){
            let reg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
            if(!reg.test(mobile)){
                error && error(errorMsg[3]);
                return false;
            }
        }
        let data = {
            mobile:mobile,
            token:token
        }
        axios.request({
            url: url.send.SmsCode,
            data,
            method: 'post'
        }).then(resp=>{
            success && success(resp);
        })
    }
    /**
     * 校验验证码
     * @param {*} param0 
     */
    checkSmscode({mobile,code,key,success,error}){
        if(!mobile){error && error(errorMsg[0]);return false}
        if(!code){error && error(errorMsg[1]);return false}
        let data = {
            mobile:mobile,
            code:code,
            key:key
        }
        axios.request({
            url: url.send.checkSmsCode,
            data,
            method: 'post'
        }).then(resp=>{
            if(resp){
                success && success(resp);
            }else error && error(errorMsg[2])    
        })
    }


    getGtCaptchaUrl(url){
        return axios.request({
            url:url,
            method:'get'
        })
    }

    validateGt(url,data){
        return axios.request({
            url:url,
            data,
            method:'post'
        })
    }

}

//注释是因为要使每个打开的tab都创建一个Db类，做到字段不共享
export const getDictList = () => {
    return axios.request({
      url: url.dict.list,
      method: 'post'
    })
}
const db = new Db()
export default db;


// WEBPACK FOOTER //
// ./src/api/db.js